import React, {lazy} from 'react';
import {Route, IndexRoute} from 'react-router';
import {getFeatureFlagStatus} from '../FeatureFlag/FeatureFlag.react';

const AssignmentBuilderLayoutWithRequiredSession = lazy(() =>
  import('./AssignmentBuilderLayout.react').then((module) => ({
    default: module.AssignmentBuilderLayoutWithRequiredSession
  }))
);

const AssignmentSettings = lazy(() =>
  import('./AssignmentSettings/AssignmentSettings.react').then((module) => ({
    default: module.AssignmentSettings
  }))
);

const AssignmentSharingV3 = lazy(async () => {
  const isABAssignmentSharingEnabled = await getFeatureFlagStatus('ab_share_tab');
  const isImprovedAssignmentsEnabled = await getFeatureFlagStatus(
    'ab_improve_assignments_transition_2'
  );
  if (isABAssignmentSharingEnabled && isImprovedAssignmentsEnabled) {
    return import('./Document/AssignmentSharing/AssignmentSharingV3.react').then((module) => ({
      default: module.AssignmentSharing
    }));
  }
  return import('./Document/AssignmentSharing/AssignmentSharingV2.react').then((module) => ({
    default: module.AssignmentSharing
  }));
});

const DocumentContentDiscovery = lazy(() =>
  import('./Document/DocumentContentDiscovery/DocumentContentDiscovery.react')
);

const ReviewQuestions = lazy(() => import('./ViewAssignment/ViewAssignment.react'));

const ContentDiscoveryRoutes = (
  <Route
    path='/assignment-builder/create-assignment'
    component={AssignmentBuilderLayoutWithRequiredSession}
  >
    <IndexRoute component={DocumentContentDiscovery} />
    {/* Create routes */}
    <Route path='settings' component={AssignmentSettings} />
    <Route path='classroom/:classroomId/settings' component={AssignmentSettings} />
    <Route
      path='classroom/:classroomId/student/:studentId/settings'
      component={AssignmentSettings}
    />
    <Route path='confirm' component={AssignmentSharingV3} />
    {/* Edit routes */}
    <Route path='folder/:folderId' component={DocumentContentDiscovery} />
    <Route path=':assignmentId' component={ReviewQuestions} />
    <Route path=':assignmentId/settings' component={AssignmentSettings} />
    <Route path=':assignmentId/classroom/:classroomId/settings' component={AssignmentSettings} />
    <Route
      path=':assignmentId/classroom/:classroomId/student/:studentId/settings'
      component={AssignmentSettings}
    />
    <Route path=':assignmentId/confirm' component={AssignmentSharingV3} />
  </Route>
);

export default ContentDiscoveryRoutes;
